import FakeUi from '../../shared/loaders/FakeUi';

import './mobileHeaderLoader.scss';

const MobileHeaderLoader = () => {
  return (
    <div className="mobile-header mobile-header--loader">
      <div className="departure-date-time">
        <div className="departure-date-time__left-container">
          <div className="departure-date-time__day-container">
            <div className="departure-date-time__day">
              <FakeUi />
            </div>
          </div>
          <div className="departure-date-time__weekday-month">
            <div className="departure-date-time__month">
              <FakeUi />
            </div>
            <div className="departure-date-time__weekday">
              <FakeUi />
            </div>
          </div>
        </div>
        <div className="departure-date-time__right-container">
          <div className="departure-date-time__time-flight-link">
            <div className="departure-date-time__departure-time">
              <FakeUi />
            </div>
            <div className="departure-date-time__flight-details-link">
              <FakeUi />
            </div>
          </div>
        </div>
      </div>
      <div className="mobile-header__title">
        <div className="mobile-header__title-fake">
          <FakeUi />
        </div>
      </div>
    </div>
  );
};

export default MobileHeaderLoader;
